import config from "shared/config";
import { useEffect } from "react";
import { Institution } from "shared/institution";
import { Location, useLocation } from "react-router-dom";

type OneTrustProps = {
  institution?: Institution;
};

function isOneTrustLocation({ pathname }: Location): boolean {
  switch (pathname) {
    case "/splash":
      return true;

    default:
      return false;
  }
}

const OneTrust = ({ institution }: OneTrustProps) => {
  const location = useLocation();

  const oneTrustId = config.oneTrustId;
  const enableOneTrust =
    isOneTrustLocation(location) ||
    (institution?.features?.enableOneTrust ?? false);

  useEffect(() => {
    if (!enableOneTrust) {
      return;
    }

    const head = document.getElementsByTagName("head")[0];
    const script = document.createElement("script");
    script.setAttribute(
      "src",
      "https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js",
    );
    script.setAttribute("data-domain-script", oneTrustId);
    head.appendChild(script);

    return () => {
      document.querySelector("#onetrust-consent-sdk")?.remove();
      script.remove();
    };
  }, [oneTrustId, enableOneTrust]);

  return null;
};

export default OneTrust;
